/**
 * Display helpers for the logged-in user (JWT + /api/auth/me profile).
 */

export function getDisplayName(user) {
  if (!user) return "";
  const p = user.profile;
  const first = p?.firstname ?? user.firstname;
  const last = p?.lastname ?? user.lastname;
  const combined = [first, last].filter(Boolean).join(" ").trim();
  if (combined) return combined;
  return p?.username || user.username || p?.email || user.email || "User";
}

/** Role names: prefer enriched profile roles, else JWT string list */
export function getRoleNames(user) {
  const fromProfile = user?.profile?.roles;
  if (Array.isArray(fromProfile) && fromProfile.length) {
    return fromProfile.map((r) => (typeof r === "string" ? r : r?.name)).filter(Boolean);
  }
  const jwtRoles = user?.roles;
  if (Array.isArray(jwtRoles) && jwtRoles.length) return jwtRoles;
  return [];
}

export function getRolesSummary(user) {
  const names = getRoleNames(user);
  if (!names.length) return "Member";
  return names.join(", ");
}

export function getInitials(user) {
  const name = getDisplayName(user);
  if (!name || name === "User") {
    const email = user?.profile?.email || user?.email;
    if (email && typeof email === "string") return email[0].toUpperCase();
    return "?";
  }
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}
